module.exports = __webpack_public_path__ + "static/media/logo_catalx.c57a0a63.svg";